import { Field, ComponentRendering } from "@sitecore-jss/sitecore-jss-nextjs";

export const getTopicTitle = (
  rendering: ComponentRendering,
): Field<string> | undefined => {
  const topic = rendering?.fields?.topic;
  if (topic && "fields" in topic && topic.fields?.title) {
    return topic.fields.title as Field<string>;
  }
};
